






























































































import {Vue, Component} from 'vue-property-decorator';
import {State} from 'vuex-class';
import PageTitle from '@/components/common/PageTitle.vue';
import ContentBottom from './ContentBottom.vue';
import {GetAccumulationsSummaryRequest, GetAccumulationsSummary, Mall, GetAccumulationsExcelRequest} from 'supporter';
import {AccumulationsDaily, StartAndEndYmdHm} from '@/types';
import {getFirstAndEndDay} from '@/utils/commonUtils';

import {writeExcel} from '@/utils/excel';
import {i18nAllObject, i18nInObjectList} from '@/utils/i18n';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import {getToday, addMonth, getBeforeDate} from '@/utils/dateUtils';
import {changeDateFormat} from '@/utils/dateUtils';
import ItemTable from '@/components/common/ItemTable.vue';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';

@Component({
  components: {
    ExcelCreateButton,
    PageTitle,
    ContentBottom,
    CompSelectBox,
    PeriodDateCalendar,
    ItemTable
  }
})
export default class AccumulationMain extends Vue {
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private accumulationsSummary: any = [];
  private accumulationsDaily: AccumulationsDaily[] = [];
  private totalCount: any = 0;
  private size: number = 30;
  private excelContent: any = [];

  private startYmdt: string = addMonth(new Date(), -1);
  private endYmdt: string = getToday();
  private PeriodOption = {
    name: 'startPeriod',
    periodTypes: ['1w', '1m', '3m', '6m', '1y'],
    period: '1m'
  };
  private periodTypeArr: any = [
    {value: 'monthSelect', name: 'ACCUMULATION_MAIN_SEARCH_DATE_MONTH_SELECT'},
    {value: 'periodSelect', name: 'ACCUMULATION_MAIN_SEARCH_DATE_PERIOD_SELECT'}
  ];
  private yearArr: number[] = [2017, 2018, 2019, 2020];
  private monthArr: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  private periodType: string = 'monthSelect';
  private theYear: number = 2020;
  private theMonth: number = 4;
  private formData: GetAccumulationsSummaryRequest = {
    params: {
      mallNo: null,
      startDateTime: '',
      endDateTime: ''
    }
  };
  private pageSize: number = 30;

  private created() {
    this.gridPropsOne.options.header = i18nInObjectList(this, this.gridPropsOne.options.header, 'complexColumns', 'header');
    this.gridPropsOne = i18nInObjectList(this, this.gridPropsOne, 'columns', 'header');
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.formData.params.mallNo = this.malls[0].mallNo;
    this.caculateTime();
    this.getSummary();
  }
  private excelInfo: any = {
    excelDownInfo: {
      columns: {
        mallName: 'ACCUMULATION_MAIN_BOTTOM_TABLE_HEADER_ONE',
        memberNo: 'ACCUMULATION_MAIN_MEMBER_NO',
        memberGradeName: 'ACCUMULATION_MAIN_MEMBER_GRADE_NAME',
        memberGroupNames: 'ACCUMULATION_MAIN_MEMBER_GROUP_NAME',
        memberName: 'ACCUMULATION_MAIN_MEMBER_NAME',
        memberId: 'ACCUMULATION_MAIN_MEMBER_ID',
        accumulationStatusName: 'ACCUMULATION_MAIN_ACCUMULAGION_STATUS_NAME',
        reasonDetail: 'ACCUMULATION_MAIN_REASON_DETAIL',
        addAccumulation: 'ACCUMULATION_MAIN_ADD_ACCUMULATION',
        subAccumulation: 'ACCUMULATION_MAIN_SUB_ACCUMULATION',
        orderNo: 'ACCUMULATION_MAIN_ORDER_NO',
        orderYmdt: 'ACCUMULATION_MAIN_ORDER_YMDT',
        paymentRequestAccumulation: 'ACCUMULATION_MAIN_PAYMENT_ACCUMULATION',
        accumulationPaymentRequestNo: 'ACCUMULATION_MAIN_REQUEST_NO',
        paymentYmdt: 'ACCUMULATION_MAIN_PAYMENT_YMDT',
        addRegisterYmdt: 'ACCUMULATION_MAIN_ADD_REGISTER_YMDT',
        subRegisterYmdt: 'ACCUMULATION_MAIN_SUB_REGISGER_YMDT'
      },
      fileName: '',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {
        addAccumulation: (data: any): any => {
          if (data.value) {
            return data.value.toLocaleString();
          } else {
            return '0';
          }
        },
        subAccumulation: (data: any): any => {
          if (data.value) {
            return data.value.toLocaleString();
          } else {
            return '0';
          }
        },
        paymentRequestAccumulation: (data: any): any => {
          if (data.value) {
            return data.value.toLocaleString();
          } else {
            return '0';
          }
        },
        addRegisterYmdt: (data: any): any => {
          if (data.value) {
            return data.value.substring(0, 16);
          }
        },
        paymentYmdt: (data: any): any => {
          if (data.value) {
            return data.value.substring(0, 16);
          }
        },
        registerYmdt: (data: any): any => {
          if (data.value) {
            return data.value.substring(0, 16);
          }
        },
        subRegisterYmdt: (data: any): any => {
          if (data.value) {
            return data.value.substring(0, 16);
          }
        }
      }
    }
  };
  private getExcelDownloadParams(type: string): any {
    let theDateObj: any = this.formatterTime();
    return {
      page: 1,
      pageSize: 10000,
      mallNo: this.formData.params.mallNo,
      type: type,
      startDateTime: theDateObj.startYmd,
      endDateTime: theDateObj.endYmd
    }
  }
  private handleExcelDown(type: string): void {
    let theDateObj: any = this.formatterTime();

    let request: GetAccumulationsExcelRequest = {
      params: {
        page: 1,
        pageSize: 10000,
        mallNo: this.formData.params.mallNo,
        type: type,
        startDateTime: theDateObj.startYmd,
        endDateTime: theDateObj.endYmd
      }
    };

    this.$api.getAccumulationsExcel(request).then((res: any): any => {
      this.excelContent = [];
      this.excelContent = res.data;
      if (this.excelContent && this.excelContent.length > 0) {
        let columns = i18nAllObject(this, this.excelInfo.excelDownInfo.columns);
        let fileName: any = '';
        if (type === 'GRADE') {
          fileName = 'accumulation_grade_';
        } else {
          fileName = 'accumulation_group_';
        }
        if (this.excelInfo.excelDownInfo.nameDateFormat !== undefined) {
          fileName += changeDateFormat(new Date(), this.excelInfo.excelDownInfo.nameDateFormat);
        }
        writeExcel(this.excelContent, columns, fileName, this.excelInfo.excelDownInfo.formatters);
      } else {
        alert(this.$t('COMMON_NOT_DATA'));
      }
    });
  }

  private caculateTime(): void {
    let timeStr: any = addMonth(new Date(), 0);
    this.theYear = Number(timeStr.substring(0, 4));
    this.theMonth = Number(timeStr.substring(5, 7));
    this.yearArr = [];
    this.yearArr = [this.theYear, this.theYear - 1, this.theYear - 2, this.theYear - 3];
  }
  private handleSearch(): void {
    this.getSummary();
    this.search(1);
  }
  private formatterTime(): any {
    let theDateObj: StartAndEndYmdHm;
    let timeStr: any = addMonth(new Date(), 0);
    if (this.periodType === 'monthSelect') {
      theDateObj = getFirstAndEndDay(this.theYear, this.theMonth);
      if (this.theMonth === Number(timeStr.substring(5, 7))) {
        theDateObj.endYmd = getBeforeDate(-1) + ' 23:59:59';
      } else {
        theDateObj.endYmd = theDateObj.endYmd.substring(0, 10) + ' 23:59:59';
      }
    } else {
      theDateObj = {startYmd: this.startYmdt + ' 00:00:00', endYmd: this.endYmdt + ' 23:59:59'};
    }
    return theDateObj;
  }
  private async getSummary(): Promise<any> {
    let theDateObj: any = this.formatterTime();
    let theObj = {
      params: {
        mallNo: this.formData.params.mallNo,
        startDateTime: theDateObj.startYmd,
        endDateTime: theDateObj.endYmd
      }
    };
    let num1: any = 0;
    let num2: any = 0;
    await this.$api.getAccumulationsSummary(theObj).then((res: any): any => {
      num1 = res.data.accumulateAmount;
      num2 = res.data.deductionAmount;
    });

    let request: any = {
      params: {
        mallNo: this.formData.params.mallNo,
        startDateTime: null,
        endDateTime: getBeforeDate(-1) + ' 23:59:59'
      }
    };
    await this.$api.getAccumulationsSummary(request).then((res: any) => {
      res.data.totalAccumulate = num1;
      res.data.selectedDeduction = num2;
      this.accumulationsSummary = [res.data as GetAccumulationsSummary];
    });
  }
  private defaultTotalCount: number = 0;
  private search(page: number = 1, size?: number): void {
    let theDateObj: any = this.formatterTime();
    let theObj: any = {
      params: {
        mallNo: this.formData.params.mallNo,
        startDateTime: theDateObj.startYmd,
        endDateTime: theDateObj.endYmd
      }
    };
    theObj.params.page = page;
    // 选中的购物中心
    let theMallObj: any[] = this.malls.filter((item: any) => {
      return item.mallNo === this.formData.params.mallNo;
    });
    // 判断search函数 是否接收到 size参数， 如果接收到 size参数 说明是通过选择size selectBox 进入到这个函数
    if (size) {
      this.size = size;
      // 通过selectBox进入到本函数 首先会判断 API返回的条数 是否大于 现在你选中按钮
      // 如果大于选中按钮的条数 才会重新请求数据
      if (this.defaultTotalCount > size) {
        theObj.params.pageSize = this.size;
        this.$api.getAccumulationsDaily(theObj).then((res: any) => {
          this.defaultTotalCount = res.data.totalCount;
          let theRes: any = res.data.contents.map((item: any) => {
            Vue.set(item, 'mall', this.$t(theMallObj[0].mallName));
            Vue.set(item, 'mallNo', theMallObj[0].mallNo);
            return item;
          });
          this.accumulationsDaily = theRes;
        });
      }
    } else {
      // 没有收到size参数 说明 是页面初始化是进入本函数 或者通过 点击 조회 按钮进入本函数
      theObj.params.pageSize = this.size;
      this.$api.getAccumulationsDaily(theObj).then((res: any) => {
        // 页面初始化进入参数是 发送api请求获取到数据个数 把这个 个数设置成这个类的全局状态 defaultTotalCount（默认值为 0 ）
        this.defaultTotalCount = res.data.totalCount;
        let theRes: any = res.data.contents.map((item: any) => {
          Vue.set(item, 'mall', this.$t(theMallObj[0].mallName));
          Vue.set(item, 'mallNo', theMallObj[0].mallNo);
          return item;
        });
        this.accumulationsDaily = theRes;
      });
    }
  }

  private reset(): void {
    this.periodType = 'monthSelect';
    this.formData = {
      params: {
        mallNo: this.malls[0].mallNo,
        startDateTime: '',
        endDateTime: ''
      }
    };
    this.caculateTime();
    (this.$refs.dateCalendar as any).clickPeriod('1m');
  }

  // ====== For grid ========
  private contentBottomOption: any = {
    haveConfigBtn: true,
    haveRigthBtn: true,
    haveExcelDownBtn: false,
    excelDownInfo: {
      columns: {
        mallName: 'ACCUMULATION_MAIN_BOTTOM_TABLE_HEADER_ONE',
        date: 'ACCUMULATION_MAIN_DATE',
        status: 'ACCUMULATION_MAIN_STATUS',
        detailReason: 'ACCUMULATION_MAIN_DETAIL_RESEAN',
        giveAccumulationAmt: 'ACCUMULATION_MAIN_GIVE',
        subtractionAccumulationAmt: 'ACCUMULATION_MAIN_SUBSTRUC',
        memberNo: 'ACCUMULATION_MAIN_MEMBER_NO',
        registerAdminName: 'ACCUMULATION_MAIN_REGISTER_ADMIN_NAME'
      },
      fileName: 'daily_point_',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {
        status: (data: any): any => {
          let name: any = '';
          if (data.value === 'GIVE') {
            name = `${window.$t('ACCUMULATION_MAIN_GIVE')}`;
          } else if (data.value === 'SUBTRACTION') {
            name = `${window.$t('ACCUMULATION_MAIN_SUBSTRUC')}`;
          }
          return name;
        }
      }
    }
  };
  private gridPropsOne = {
    options: {
      pageOptions: {},
      header: {
        height: 66,
        complexColumns: [
          {
            header: 'ACCUMULATION_MAIN_TOP_TABLE_COMPLEX_HEADER_ONE',
            name: 'summary',
            childNames: ['accumulateAmount', 'deductionAmount', 'availableAmount']
          },
          {
            header: 'ACCUMULATION_MAIN_TOP_TABLE_COMPLEX_HEADER_TWO',
            name: 'selectedSummary',
            childNames: ['totalAccumulate', 'selectedDeduction']
          }
        ]
      }
    },
    haveDataBodyHeight: 480,
    scrollY: false,
    copyOptions: {
      useFormattedValue: true
    },
    columns: [
      {
        header: 'ACCUMULATION_MAIN_TOP_TABLE_HEADER_ONE',
        name: 'accumulateAmount',
        align: 'right',
        minWidth: 85,
        formatter: (data: any) => {
          return data.row.accumulateAmount.toLocaleString();
        }
      },
      {
        header: 'ACCUMULATION_MAIN_TOP_TABLE_HEADER_TWO',
        name: 'deductionAmount',
        align: 'right',
        minWidth: 85,
        formatter: (data: any) => {
          return data.row.deductionAmount.toLocaleString();
        }
      },
      {
        header: 'ACCUMULATION_MAIN_TOP_TABLE_HEADER_THREE',
        name: 'availableAmount',
        align: 'right',
        minWidth: 85,
        formatter: (data: any) => {
          return data.row.availableAmount.toLocaleString();
        }
      },
      {
        header: 'ACCUMULATION_MAIN_TOP_TABLE_HEADER_ONE',
        name: 'totalAccumulate',
        align: 'right',
        minWidth: 85,
        formatter: (data: any) => {
          return data.row.totalAccumulate.toLocaleString();
        }
      },
      {
        header: 'ACCUMULATION_MAIN_TOP_TABLE_HEADER_TWO',
        name: 'selectedDeduction',
        align: 'right',
        minWidth: 85,
        formatter: (data: any) => {
          return data.row.selectedDeduction.toLocaleString();
        }
      }
    ]
  };
  private gridProps = {
    options: {
      header: {
        height: 33
      },

      columnOptions: {
        minWidth: 50,
        resizable: true
      },

      // keyColumnName: 'orderProductOptionNo',
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      },
      minRowHeight: 35,
      displayRowCount: 10,
      isInitialRequest: true,
      useClientSort: false
    },
    columns: [
      {
        header: 'ACCUMULATION_MAIN_BOTTOM_TABLE_HEADER_ONE',
        name: 'mall',
        align: 'center',
        minWidth: 20
      },
      {
        header: 'ACCUMULATION_MAIN_BOTTOM_TABLE_HEADER_TWO',
        name: 'date',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'ACCUMULATION_MAIN_BOTTOM_TABLE_HEADER_THREE',
        name: 'accumulateAmount',
        align: 'right',
        minWidth: 85,
        formatter: (data: any) => {
          return data.row.accumulateAmount.toLocaleString();
        }
      },
      {
        header: 'ACCUMULATION_MAIN_BOTTOM_TABLE_HEADER_FOUR',
        name: 'deductionAmount',
        align: 'right',
        minWidth: 85,
        formatter: (data: any) => {
          return data.row.deductionAmount.toLocaleString();
        }
      },
      {
        header: 'ACCUMULATION_MAIN_BOTTOM_TABLE_HEADER_FIVE',
        name: 'popup',
        align: 'center',
        minWidth: 85,
        formatter: (data: any) => {
          return `<a href="javascript:window.open(\'\/accumulation/list?mallName=${data.row.mall}&mallNo=${data.row.mallNo}&date=${data.row.date}&accumulateAmount=${data.row.accumulateAmount}&deductionAmount=${data.row.deductionAmount}\',\'AccumulationPopup\',\'top=100, left=350, scrollbars=no, width=900, height=700, resizable=no\');" class="view">보기</a>`;
        }
      }
    ]
  };
}
